import ProfilePageInvira from '../pages/ProfilePage/ProfilePageInvira.vue';

/**
 * Override de la ruta /me para usar el perfil Invira con modal de cambio de contraseña
 * que tiene validación de formato (mínimo 8 caracteres, número y carácter especial).
 */
export default [
  {
    name: 'me',
    path: '/me',
    component: ProfilePageInvira,
    meta: { requiresAuth: true },
  },
];
